export const environment = {
  production: true,
  apiUrl: "https://payments.sube.la/api/v1/",
  paypal_env: 'production',
  openpay_production: true,
  cybersource_org_id: 'k8vif92e',
  serfinsa_songbird_url: 'https://static.client.cardinaltrusted.com/songbird/v2.0.0/songbird.js',
};



// WEBPACK FOOTER //
// /app/frontend/src/environments/environment.ts